import PropTypes from 'prop-types';
import React from 'react';
import Switch from 'react-switch';

function Toggle({ id, checked, onChange, name, disabled, className, icons }) {
    const handleChange = value => {
        onChange({ target: { checked: value, type: 'checkbox', name } });
    };

    return (
        <Switch
            id={id}
            checked={!!checked}
            onChange={handleChange}
            disabled={disabled}
            className={className}
            checkedIcon={icons !== false ? undefined : false}
            uncheckedIcon={icons !== false ? undefined : false}
            height={22}
            width={48}
            handleDiameter={18}
        />
    );
}

Toggle.propTypes = {
    id: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    icons: PropTypes.bool
};

export default Toggle;
